import { InvoiceFilters } from "@common/contracts/invoice.contract";
import { omit } from "@common/helpers/objects";
import { InvoiceStatusFilter } from "@common/schemas/domains/invoice/invoice-status-filter.schema";
import { InvoiceStatus } from "@common/types/invoice";
import { narrowStatusFilterToStatus, readStatusFilter } from "./statusFilter";

type InvoiceStatusFilterFields = Pick<
    InvoiceFilters,
    "invoiceStatusFilter" | "invoiceStatuses" | "externalInvoiceStatuses"
>;

const LEGACY_STATUS_KEYS = [
    "invoiceStatuses",
    "externalInvoiceStatuses",
] as const satisfies ReadonlyArray<keyof InvoiceStatusFilterFields>;

export const INVOICE_STATUS_VALUES = Object.values(InvoiceStatus);

export function isInvoiceStatus(
    value: string | number,
): value is InvoiceStatus {
    return INVOICE_STATUS_VALUES.some((status) => status === value);
}

export function readInvoiceStatusFilter(
    filters: InvoiceStatusFilterFields,
): InvoiceStatusFilter | undefined {
    return readStatusFilter({
        statusFilter: filters.invoiceStatusFilter,
        kickStatuses: filters.invoiceStatuses,
        externalStatuses: filters.externalInvoiceStatuses,
    });
}

export function normalizeInvoiceStatusFilters<
    T extends InvoiceStatusFilterFields,
>(filters: T) {
    const invoiceStatusFilter = readInvoiceStatusFilter(filters);
    const rest = omit(filters, [...LEGACY_STATUS_KEYS]);
    return invoiceStatusFilter ? { ...rest, invoiceStatusFilter } : rest;
}

export function narrowInvoiceStatusFilterToStatus({
    statusFilter,
    status,
}: {
    statusFilter: InvoiceStatusFilter;
    status: InvoiceStatus;
}): InvoiceStatusFilter | null {
    return narrowStatusFilterToStatus({
        statusFilter,
        status,
        allStatuses: INVOICE_STATUS_VALUES,
    });
}
